import { createCommentSpans } from '@rd-web-markets/shared/dist/comments/commentsDomUtils';
import React, { useCallback, useEffect, useState } from 'react';
import CommentsSection from './CommentsSection';
import CreateComment from './CreateComment';
import commentsService from '@rd-web-markets/shared/dist/services/comments.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
export default function CommentsView(_ref) {
  let {
    editor,
    modelClass,
    modelId,
    modelField
  } = _ref;
  const [selectedCommentsSpanId, setSelectedCommentsSpanId] = useState(null);
  const [commentsViewVisible, setCommentsViewVisible] = useState(true);
  const [comments, setComments] = useState([]);
  const fetchComments = useErrorHandling(useCallback(async () => {
    const result = await commentsService.all(modelId, modelClass, selectedCommentsSpanId, modelField);
    setComments((result === null || result === void 0 ? void 0 : result.comments) || []);
    // if (result.comments?.length) {
    //   // setIsCommenting(true)
    // }
  }, [modelClass, modelField, modelId, selectedCommentsSpanId]));
  useEffect(() => {
    fetchComments();
  }, [fetchComments]);
  const updateStateForCloseButton = useCallback(() => {
    setCommentsViewVisible(false);
    editor.ui.registry.getAll().buttons.comments_view_toggle.toggleState();
  });
  useEffect(() => {
    editor === null || editor === void 0 || editor.on('Comments:commentSpanIdChanged', _ref2 => {
      let {
        payload
      } = _ref2;
      setSelectedCommentsSpanId(payload.commentSpanId);
    });
    editor === null || editor === void 0 || editor.on('Comments:commentViewToggled', _ref3 => {
      let {
        payload
      } = _ref3;
      setCommentsViewVisible(payload.commentsViewVisible);
    });
  }, [editor]);
  const onAddComment = newSetOfComments => {
    setComments(newSetOfComments);
    editor.AYMING_MODULES.find(m => m.name === 'comments').createCommentHighlightAndUpdateContent(editor);
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "commentsView",
    className: "p-3",
    style: {
      width: '300px',
      backgroundColor: 'white',
      zIndex: 100,
      border: '1px solid #0078b9',
      marginLeft: '5px',
      display: commentsViewVisible ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-3",
    style: {
      justifyContent: 'space-between',
      borderBottom: '1px solid grey'
    }
  }, "COMMENTS", /*#__PURE__*/React.createElement("div", {
    title: "Close",
    onClick: () => updateStateForCloseButton(),
    style: {
      cursor: 'pointer'
    }
  }, "X")), /*#__PURE__*/React.createElement(CommentsSection, {
    comments: comments
  }), selectedCommentsSpanId && /*#__PURE__*/React.createElement(CreateComment, {
    modelClass: modelClass,
    modelId: modelId,
    modelField: modelField,
    spanId: selectedCommentsSpanId,
    onCreateComment: onAddComment
  }));
}